import React, { useState, useEffect, useRef } from 'react';
import { postAPI } from '../../../app/api';
import { Link } from 'react-router-dom';

export default function HomePopupSection() {
    const [popupData, setPopupData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true;
            fetchPopupData();
        }
    }, []);

    const fetchPopupData = async () => {
        try {
            const response = await postAPI('popup-data/fetchData/home', {});
            console.log('📦 Popup API Response:', response);
            if (response?.status === 1 && response?.data?.length > 0) {
                const popup = response.data[0];
                console.log('📋 Popup Data:', popup);
                console.log('🔢 Frequency value:', popup.frequency, 'Type:', typeof popup.frequency);
                if (popup.is_active === 1 && popup.image) {
                    // Check frequency to determine if popup should show
                    if (shouldShowPopup(popup)) {
                        setPopupData(popup);
                        // Delay popup display slightly for better UX
                        setTimeout(() => {
                            setShowPopup(true);
                            // Mark as shown immediately when displayed
                            markPopupAsShownImmediate(popup);
                        }, 500);
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching popup data:', error);
        }
    };

    const shouldShowPopup = (popup) => {
        // Parse frequency as integer - API returns it as string
        const frequency = parseInt(popup.frequency) || 0;
        const popupKey = `popup_shown_${popup.id}`;
        const now = new Date().getTime();

        switch (frequency) {
            case 0: // Every Visit
                return true;

            case 1: // Once Per Session
                if (sessionStorage.getItem(popupKey)) {
                    return false;
                }
                return true;

            case 2: // Once Per Day
                const lastShownDay = localStorage.getItem(`${popupKey}_day`);
                if (lastShownDay) {
                    const lastTime = parseInt(lastShownDay);
                    const oneDayMs = 24 * 60 * 60 * 1000;
                    if (now - lastTime < oneDayMs) {
                        return false;
                    }
                }
                return true;

            case 3: // Once Per Week
                const lastShownWeek = localStorage.getItem(`${popupKey}_week`);
                if (lastShownWeek) {
                    const lastTime = parseInt(lastShownWeek);
                    const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
                    if (now - lastTime < oneWeekMs) {
                        return false;
                    }
                }
                return true;

            case 4: // Once Only
                if (localStorage.getItem(`${popupKey}_once`)) {
                    return false;
                }
                return true;

            default:
                return true;
        }
    };

    const markPopupAsShown = () => {
        if (!popupData) return;
        markPopupAsShownImmediate(popupData);
    };

    // Helper function to mark popup as shown with parsed frequency
    const markPopupAsShownImmediate = (popup) => {
        const frequency = parseInt(popup.frequency) || 0;
        const popupKey = `popup_shown_${popup.id}`;
        const now = new Date().getTime();

        console.log('📌 Marking popup as shown, frequency:', frequency);

        switch (frequency) {
            case 1: // Once Per Session
                sessionStorage.setItem(popupKey, 'true');
                break;
            case 2: // Once Per Day
                localStorage.setItem(`${popupKey}_day`, now.toString());
                break;
            case 3: // Once Per Week
                localStorage.setItem(`${popupKey}_week`, now.toString());
                break;
            case 4: // Once Only
                localStorage.setItem(`${popupKey}_once`, 'true');
                break;
            default:
                break;
        }
    };

    const handleClose = () => {
        markPopupAsShown();
        setShowPopup(false);
    };

    const handleOverlayClick = (e) => {
        // Close if clicked on overlay (not on the image)
        if (e.target.classList.contains('popup-overlay')) {
            handleClose();
        }
    };

    if (!showPopup || !popupData?.image) {
        return null;
    }

    return (
        <div
            className="popup-overlay"
            onClick={handleOverlayClick}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                animation: 'fadeIn 0.3s ease-in-out'
            }}
        >
            <div
                style={{
                    position: 'relative',
                    maxWidth: '90vw',
                    maxHeight: '90vh'
                }}
            >
                {/* Close Button */}
                <button
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '-15px',
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        border: 'none',
                        backgroundColor: '#fff',
                        color: '#333',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                        zIndex: 10000
                    }}
                    aria-label="Close popup"
                >
                    ×
                </button>

                {/* Popup Image */}
                <Link to={''}>
                    <img
                        src={popupData.image}
                        alt="Popup"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '85vh',
                            borderRadius: '8px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </Link>
            </div>

            <style>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
}
